import {
  CLEAR_STUDENT_ABSENCES_AND_RELATIVES,
  CLEAR_STUDENTS_REDUCER,
  CREATE_ABSENCE,
  CREATE_ABSENCE_SUCCESS,
  EDIT_ABSENCE,
  EDIT_ABSENCE_SUCCESS,
  GET_INSURANCES,
  GET_INSURANCES_SUCCESS,
  GET_STUDENT_LOCATION,
  GET_STUDENT_LOCATION_SUCCESS,
  GET_STUDENT_RELATIVES,
  GET_STUDENT_RELATIVES_FAILURE,
  GET_STUDENT_RELATIVES_SUCCESS,
  LOAD_MORE_LOCATION_REQUESTS,
  LOAD_MORE_LOCATION_REQUESTS_FAILURE,
  LOAD_MORE_LOCATION_REQUESTS_SUCCESS,
  LOAD_MORE_PAST_STUDENTS_ABSENCES,
  LOAD_MORE_PAST_STUDENTS_ABSENCES_FAILURE,
  LOAD_MORE_PAST_STUDENTS_ABSENCES_SUCCESS,
  SEARCH_LOCATION_REQUESTS_HISTORY,
  SEARCH_LOCATION_REQUESTS_HISTORY_FAILURE,
  SEARCH_LOCATION_REQUESTS_HISTORY_SUCCESS,
  SEARCH_PAST_STUDENT_ABSENCES,
  SEARCH_PAST_STUDENT_ABSENCES_FAILURE,
  SEARCH_PAST_STUDENT_ABSENCES_SUCCESS,
  SEARCH_UPCOMING_STUDENT_ABSENCES,
  SEARCH_UPCOMING_STUDENT_ABSENCES_FAILURE,
  SEARCH_UPCOMING_STUDENT_ABSENCES_SUCCESS,
  SET_STUDENT_LOCATION_LOADING,
  SHOW_MORE_PAST_STUDENTS_ABSENCES,
  START_STUDENT_LOADING,
  STOP_STUDENT_LOADING,
  REMOVE_ABSENCE,
  REMOVE_ABSENCE_SUCCESS,
  STOP_ABSENCE,
  STOP_ABSENCE_SUCCESS,
  LOAD_ABSENCE_REASONS,
  LOAD_ABSENCE_REASONS_SUCCESS,
  TOGGLE_ABSENCE_MODAL,
  ABSENCE_PENDING_FAILURE,
  UPLOAD_AVATAR,
  UPLOAD_AVATAR_SUCCESS,
  IMPORT_ROUTES_ERROR,
} from '../constants/ActionTypes';

export const clearStudentAbsencesAndRelatives = () => ({
  type: CLEAR_STUDENT_ABSENCES_AND_RELATIVES,
});

export const clearStudentsReducer = () => ({
  type: CLEAR_STUDENTS_REDUCER,
});

export const toggleAbsenceModal = () => ({
  type: TOGGLE_ABSENCE_MODAL,
});

export const createAbsence = (studentId, request) => ({
  type: CREATE_ABSENCE,
  payload: { studentId, request },
});

export const createAbsenceSuccess = absence => ({
  type: CREATE_ABSENCE_SUCCESS,
  payload: { absence },
});

export const absencePendingFailure = () => ({
  type: ABSENCE_PENDING_FAILURE,
});

export const editAbsence = (studentId, absenceId, absence) => ({
  type: EDIT_ABSENCE,
  payload: { studentId, absenceId, absence },
});

export const editAbsenceSuccess = absence => ({
  type: EDIT_ABSENCE_SUCCESS,
  payload: { absence },
});

export const getInsurances = studentId => ({
  type: GET_INSURANCES,
  payload: studentId,
});

export const getInsurancesSuccess = insurance => ({
  type: GET_INSURANCES_SUCCESS,
  payload: { insurance },
});

export const getStudentLocation = studentId => ({
  type: GET_STUDENT_LOCATION,
  payload: { studentId },
});

export const getStudentLocationSuccess = location => ({
  type: GET_STUDENT_LOCATION_SUCCESS,
  payload: { location },
});

export const getStudentRelatives = studentId => ({
  type: GET_STUDENT_RELATIVES,
  payload: { studentId },
});

export const getStudentRelativesFailure = () => ({
  type: GET_STUDENT_RELATIVES_FAILURE,
});

export const getStudentRelativesSuccess = (relatives, studentId) => ({
  type: GET_STUDENT_RELATIVES_SUCCESS,
  payload: { relatives, studentId },
});

export const loadMoreLocationRequests = (studentId, query) => ({
  type: LOAD_MORE_LOCATION_REQUESTS,
  payload: { studentId, query },
});

export const loadMoreLocationRequestsFailure = () => ({
  type: LOAD_MORE_LOCATION_REQUESTS_FAILURE,
});

export const loadMoreLocationRequestsSuccess = (requests, pageCount) => ({
  type: LOAD_MORE_LOCATION_REQUESTS_SUCCESS,
  payload: { requests, pageCount },
});

export const loadMorePastStudentAbsences = (studentId, query) => ({
  type: LOAD_MORE_PAST_STUDENTS_ABSENCES,
  payload: { studentId, query },
});

export const loadMorePastStudentAbsencesFailure = () => ({
  type: LOAD_MORE_PAST_STUDENTS_ABSENCES_FAILURE,
});

export const loadMorePastStudentAbsencesSuccess = (absences, pageCount, studentId) => ({
  type: LOAD_MORE_PAST_STUDENTS_ABSENCES_SUCCESS,
  payload: { absences, pageCount, studentId },
});

export const searchLocationRequestsHistory = (studentId, query) => ({
  type: SEARCH_LOCATION_REQUESTS_HISTORY,
  payload: { studentId, query },
});

export const searchLocationRequestsHistoryFailure = () => ({
  type: SEARCH_LOCATION_REQUESTS_HISTORY_FAILURE,
});

export const searchLocationRequestsHistorySuccess = (requests, pageCount) => ({
  type: SEARCH_LOCATION_REQUESTS_HISTORY_SUCCESS,
  payload: { requests, pageCount },
});

export const searchPastStudentAbsences = (studentId, query) => ({
  type: SEARCH_PAST_STUDENT_ABSENCES,
  payload: { studentId, query },
});

export const searchPastStudentAbsencesFailure = () => ({
  type: SEARCH_PAST_STUDENT_ABSENCES_FAILURE,
});

export const searchPastStudentAbsencesSuccess = (absences, studentId, pageCount) => ({
  type: SEARCH_PAST_STUDENT_ABSENCES_SUCCESS,
  payload: { absences, studentId, pageCount },
});

export const searchUpcomingStudentAbsences = (studentId, query) => ({
  type: SEARCH_UPCOMING_STUDENT_ABSENCES,
  payload: { studentId, query },
});

export const searchUpcomingStudentAbsencesFailure = () => ({
  type: SEARCH_UPCOMING_STUDENT_ABSENCES_FAILURE,
});

export const searchUpcomingStudentAbsencesSuccess = (absences, studentId) => ({
  type: SEARCH_UPCOMING_STUDENT_ABSENCES_SUCCESS,
  payload: { absences, studentId },
});

export const setStudentLocationLoading = isLoading => ({
  type: SET_STUDENT_LOCATION_LOADING,
  payload: { isLoading },
});

export const showMorePastAbsences = () => ({
  type: SHOW_MORE_PAST_STUDENTS_ABSENCES,
});

export const startLoading = () => ({
  type: START_STUDENT_LOADING,
});

export const stopLoading = () => ({
  type: STOP_STUDENT_LOADING,
});

export const loadAbsenceReasons = () => ({
  type: LOAD_ABSENCE_REASONS,
});
export const loadAbsenceReasonsSuccess = reasons => ({
  type: LOAD_ABSENCE_REASONS_SUCCESS,
  payload: { reasons },
});

export const removeAbsence = (studentId, absenceId) => ({
  type: REMOVE_ABSENCE,
  payload: { studentId, absenceId },
});

export const removeAbsenceSuccess = absenceId => ({
  type: REMOVE_ABSENCE_SUCCESS,
  payload: { absenceId },
});

export const stopAbsence = (studentId, absenceId) => ({
  type: STOP_ABSENCE,
  payload: { studentId, absenceId },
});

export const stopAbsenceSuccess = absenceId => ({
  type: STOP_ABSENCE_SUCCESS,
  payload: { absenceId },
});

export const uploadAvatar = studentId => ({
  type: UPLOAD_AVATAR,
  payload: { studentId },
});

export const uploadAvatarSuccess = payload => ({
  type: UPLOAD_AVATAR_SUCCESS,
  payload,
});

export const uploadAvatarError = payload => ({
  type: IMPORT_ROUTES_ERROR,
  payload,
});
